import type { IconProps as FeatherProps } from 'react-feather';
import { X } from 'react-feather';
import { cx } from '@trinity/chat-components/utils';
import styles from './style.module.css';

type Props = {
  crossProps?: FeatherProps;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  size?: number;
};

const XCircle = ({ crossProps = {}, ...props }: Props) => {
  const { className: crossClassName, ...otherCrossProps } = crossProps;

  return (
    <div
      className={cx(styles.root, props.className, props.disabled && styles.disabled)}
      onClick={props.disabled ? () => { } : props.onClick}>
      <X className={cx(styles.cross, crossClassName)} size={props.size} {...otherCrossProps} />
    </div>
  );
};

export { XCircle };
export default XCircle;
